import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  clinicsList: [],
  clinicsListMap: {},
  userClinic: {},
  clinicDevicesList: [],
  userClinicLoading: false,
  totalSleepSessions: 0,
  newUsers: 0,
  userClinicImage: '',
  todaySleepSessions: 0,
  weeklyReportsLoading: false,
  loading: false,
  redirect: false,
  newClinic: '',
  editedClinic: '',
  clinicUsers: [],
  clinicUsersLoading: false,
  selectClinicModal: false,
  clinicList: [],
  reportSendLoading: false,
  reportMessage: false,
  clinicFloors: [],
  clinicFloorsLoading: false,
  clinicDetail: {
    floors: [],
    alert_recipients: [],
    daily_report_recipients: [],
  },
  clinicDetailLoading: false,
  importPCCResidentsLoading: false,
}

export default factoryReducer(initialState, actions)
